import React from "react";
import { Control, RegisterOptions } from "react-hook-form";

import { Select, InputFieldProps } from "shared/components";
import { IPeoplePickerSettings } from "shared/types";

import { useLogic } from "./useLogic";

interface Props extends Omit<InputFieldProps, "value"> {
  value?: string | number | null;
  control: Control;
  validation?: RegisterOptions;
  setFieldValue?: (field: string, value: string | null) => void;
  defaultValue?: string;
  isSearchable?: boolean;
  settings?: IPeoplePickerSettings;
}

export const SinglePeoplePicker: React.FC<Props> = ({
  value,
  defaultValue,
  placeholder,
  onChange,
  settings,
  isSearchable,
  ...rest
}) => {
  const [options] = useLogic(settings || {});

  return (
    <Select
      {...rest}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder || "@"}
      options={options}
      onChange={onChange}
      isSearchable={isSearchable}
      note={
        settings?.includeInvitedUsers
          ? ""
          : "Only registered users can be selected."
      }
    />
  );
};
